import { render } from "./screenSelect.vue?vue&type=template&id=760f1c2c&scoped=true"
import script from "./screenSelect.vue?vue&type=script&lang=js"
export * from "./screenSelect.vue?vue&type=script&lang=js"

import "./screenSelect.vue?vue&type=style&index=0&id=760f1c2c&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760f1c2c"]])

export default __exports__